export enum Unit {
  'Std.' = 'Std.',
  'm' = 'm',
  'm^2' = 'm^2',
  'm^3' = 'm^3',
  'ha' = 'ha',
  'kg' = 'kg',
  't' = 't',
  'Stück' = 'Stück',
  'fix' = 'fix',
  'Fahrt' = 'Fahrt',
  'km' = 'km'
}

export class Service {
  id?: number;
  name: string;
  description: string;
  type: ServiceType;

  measurementUnits?: MeasurementUnit[];

  /**
   * @deprecated
   */
  unit: Unit;

  /**
   * @deprecated
   */
  basePrice: number;

  /**
   * @deprecated
   */
  netPrice: number;

  /**
   * @deprecated
   */
  taxPrice: number;
}

export class MeasurementUnit {
  unit: Unit;
  basePrice: number;
  netPrice: number;
  taxPrice: number;

  estimatedQuantity?: number;
  workedQuantity?: number;
  actualQuantity?: number;

  diameter?: number;

  constructor(unit: MeasurementUnit, diameter = null) {
    this.unit = unit.unit;
    this.estimatedQuantity = +unit.estimatedQuantity;
    this.diameter = diameter;

    if (unit.basePrice || unit.basePrice === 0) {
      this.basePrice = +unit.basePrice;
    }
    if (unit.netPrice || unit.netPrice === 0) {
      this.netPrice = +unit.netPrice;
    }
    if (unit.taxPrice || unit.taxPrice === 0) {
      this.taxPrice = +unit.taxPrice;
    }

    this.workedQuantity = unit.workedQuantity ? +unit.workedQuantity : 0;
    this.actualQuantity = unit.actualQuantity ? +unit.actualQuantity : 0;

    this.setActualQuantity(unit.workedQuantity, unit.actualQuantity);
  }

  addWorkedQuantity(workedQuantity: number, actualQuantity: number) {
    this.workedQuantity += workedQuantity;
    this.setActualQuantity(actualQuantity);
  }

  private setActualQuantity(workedQuantity: number, actualQuantity?: number) {
    if (actualQuantity) {
      return;
    }
    if (this.unit !== Unit['Std.']) {
      this.actualQuantity += workedQuantity;
      return;
    }

    const integralPart = Math.trunc(workedQuantity);
    const digits = (workedQuantity - integralPart) * 100; // 0.01 , 0.36, 0.99
    if (digits <= 0) {
      this.actualQuantity += workedQuantity;
      return;
    }
    if (digits <= 25) {
      this.actualQuantity += integralPart + 0.25;
    } else if (digits <= 50) {
      this.actualQuantity += integralPart + 0.5;
    } else if (digits <= 75) {
      this.actualQuantity += integralPart + 0.75;
    } else {
      this.actualQuantity += integralPart + 1;
    }
  }

  get totalPrice() {
    const diameter = this.diameter || 1;
    return diameter * this.actualQuantity * this.netPrice + this.basePrice;
  }

  get vatPrice() {
    if (this.taxPrice === 0) {
      return 0;
    }
    return 1 + this.taxPrice / 100;
  }

  get grossPrice() {
    return this.netPrice * this.vatPrice;
  }

  get totalGrossPrice() {
    return this.totalPrice * this.vatPrice;
  }
}

export enum ServiceType {
  basic = 'klassisch',
  straw = 'ballen'
}
